import React, { useEffect } from 'react';
import { Bar, Doughnut } from 'react-chartjs-2';

const BarChart = ({ title, data }) => (
    <Bar
        data={data}
        options={{
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                y: {
                    beginAtZero: true,
                },
            },
            plugins: {
                title: {
                    display: true,
                    text: `${title}`
                },
            },
        }}
    />
);

const DoughnutChart = ({ title,  data }) => (
    <Doughnut
        data={data}
        options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                title: {
                    display: true,
                    text: `${title}`
                },
            },
        }}
    />
);

export { BarChart, DoughnutChart };
